export const COMMITMENTS_MODAL_KEY = 'commitment-modal'
